import type { StateStorage } from "zustand/middleware";

/**
 * String storage backing the persist middleware. Wraps localStorage and never
 * throws: when localStorage is missing (private mode) or rejects a write
 * (QuotaExceeded), it degrades to an in-memory map for the session.
 */
export function createSafeStorage(): StateStorage {
  const memory = new Map<string, string>();
  return {
    getItem(name) {
      try {
        const value = globalThis.localStorage?.getItem(name);
        return value != null ? value : memory.get(name) ?? null;
      } catch {
        return memory.get(name) ?? null;
      }
    },
    setItem(name, value) {
      try {
        if (globalThis.localStorage) {
          globalThis.localStorage.setItem(name, value);
        } else {
          memory.set(name, value);
        }
      } catch {
        memory.set(name, value);
      }
    },
    removeItem(name) {
      memory.delete(name);
      try {
        globalThis.localStorage?.removeItem(name);
      } catch {
        memory.delete(name);
      }
    },
  };
}
